/**
 * THE WORDS A REFUSED EMAIL KEEPS (ops #76 O6), the go-live switch for client email's twin of
 * texting's (`api/src/schedule/email-gate.ts` refuses with them and re-exports them). They live here
 * so a screen told a message was held can name the switch that held it: the office reads "client
 * email is not on" for an email and "texting is not on" for a text, and never the one for the other.
 * Each is led by the same code a refused text keeps, so a parked row reads the same whichever switch
 * held it, and each says what a person does about it.
 */
export const EMAIL_OFF =
  'not_enabled: client email is off in ops; an owner sets the email switch in Settings';
export const NOT_A_TEST_ADDRESS =
  'not_enabled: ops emails test addresses only, and this address is not one';

/** Whether a go-live refusal is the email switch's, rather than texting's. */
export function heldByEmailSwitch(refusal: string): boolean {
  return refusal === EMAIL_OFF || refusal === NOT_A_TEST_ADDRESS;
}
